import React from "react"

function FacebookIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid"
      viewBox="0 0 256 230"
    >
      <path
        fill="none"
        d="M1 115c0 19 19 37 48 47-6 30-1 54 15 63 17 10 42 3 65-18 23 20 46 28 63 19 16-10 21-36 15-66 31-10 48-26 48-45s-19-35-48-45c7-32 1-56-16-65-16-10-39-2-63 19C104 2 81-4 64 5 48 15 43 39 49 69 21 79 1 96 1 115z"
      ></path>
      <path
        fill="#53C1DE"
        d="M201 80l-7-3 1-5c5-26 2-48-11-55-11-7-31 0-50 17l-6 5-3-3c-21-18-41-26-54-19-11 7-15 27-10 53l2 7-9 3c-23 8-39 21-39 35s17 28 42 36l6 2-2 8c-5 25-1 45 11 52s32 0 52-18l5-4 6 6c19 16 38 23 50 16s16-28 11-54l-2-6 4-2c26-8 43-22 43-36s-16-27-40-35z"
      ></path>
      <path
        className="fill-current text-lightTheme-primary dark:text-darkTheme-primary"
        d="M195 142l-3 2c-3-10-7-19-12-29l11-28 7 2c21 7 34 18 34 26 0 9-14 20-37 27zm-9 19c2 11 3 21 1 30-1 7-4 12-7 14-7 4-23-2-39-16l-6-5c7-7 13-15 19-24l31-5 1 6zm-94 43c-7 2-12 2-16 0-7-4-10-20-6-41l2-7 30 4 20 24-4 4c-9 8-18 13-26 16zm-32-62c-11-3-20-8-27-14-5-5-8-9-8-13 0-8 12-19 33-26l7-2 11 28-11 29-5-2zm11-74c-5-22-2-38 5-42 8-5 25 2 42 17l4 3-20 24-30 5-1-7zm97 24l-7-11 21 3-7 20-7-12zm-40-39l14 16a284 284 0 00-27 0l13-16zM88 92l-6 12-7-20 20-3-7 11zm7 58l-20-4 7-20 6 12 7 12zm34 27l-14-16a337 337 0 0027 0l-13 16zm46-51l7 20-21 4a338 338 0 0014-24zm-15 7l-11 18a291 291 0 01-41 0l-11-18-10-18 10-18 11-18h41a291 291 0 0120 36l-9 18zm20-108c7 5 10 22 5 45l-1 5-30-5c-6-9-12-17-19-24l5-4c17-15 33-21 40-17z"
      ></path>
      <path fill="#53C1DE" d="M128 95a20 20 0 110 40 20 20 0 010-40"></path>
    </svg>
  )
}

export default FacebookIcon
